<!--
  - Copyright (c) 2021. Michael Clovis
  - This program is free software: you can redistribute it and/or modify
  -     it under the terms of the GNU Affero General Public License as published by
  -     the Free Software Foundation, either version 3 of the License, or
  -     (at your option) any later version.
  -
  -     This program is distributed in the hope that it will be useful,
  -     but WITHOUT ANY WARRANTY; without even the implied warranty of
  -     MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
  -     GNU Affero General Public License for more details.
  -
  -     You should have received a copy of the GNU Affero General Public License
  -     along with this program.  If not, see <https://www.gnu.org/licenses/>.
  -->

<template>
  <td :class="{bold:employee.id === employee.DEFAULT_ID }" ref="total" class="row rectangle">
    <div class="col-3">
      <div class="col-12">
        {{ jobType }}
      </div>
      <div class="col-12">
        {{ totalHours }} Hours

      </div>
      <div class="col-12">
        {{ Math.round(timeCardHours *100)/100}} Time Card Hours
      </div>
      <div class="col-12" v-show="showPay">
        ${{ totalPay.toFixed(2) }}

      </div>

<!--      <div v-for="jt in jobTypes.keys()" class="row  " :key="jt">-->
<!--        <div class="col-12">-->
<!--          {{ jt }}-->

<!--        </div>-->
<!--        <div class="col-12">-->
<!--          {{ jobTypes.get(jt).totalHours }}  Hours <span v-show="showPay"> &nbsp;${{ jobTypes.get(jt).totalPay.toFixed(2) }} </span>-->
<!--        </div>-->
<!--      </div>-->

    </div>
  </td>
</template>

<script>
import {User} from "../classes/User";
import {TimeCard} from "../classes/TimeCard";

export default {
  name: "ScheduleTotalColumnItem",
  data() {
    return {
      dRota: [],
      totalHours: 0,
      totalPay: 0,
      timeCardHours: 0,
      jobType: "",
      jobTypes : new Map()
    }
  },
  computed: {
    TimeCard() {
      return TimeCard
    },
    users() {
      return this.$store.state.users;
    },
    jobs() {
      return this.$store.state.jobs;
    },
  },
  mounted() {
    this.setDRota();
  },
  methods: {
    setDRota() {
      this.$forceUpdate()
      this.dRota = [];
      if (this.employee.id !== this.employee.DEFAULT_ID) {
        this.dRota = this.rota.filter(elem => {
          return elem.User.id === this.employee.id
        });
      } else {
        this.dRota = this.rota;
        //console.log(this.$refs)
        //this.$refs.total.$el.classList.add("bold");
      }
      this.totalPay = 0;
      this.totalHours = 0;
      this.timeCardHours = 0;
      for (let idx = 0; idx < this.dRota.length; idx++) {
        let userIdx = this.users.findIndex(elem => {
          return elem.id === this.dRota[idx].User.id
        })
        let jobIdx = this.jobs.findIndex((elem) => {
          return elem.name === this.dRota[idx].job;
        });
        if (userIdx === -1 || jobIdx === -1) {
          continue;
        }
        let payScale = this.users[userIdx].jobs.get(this.jobs[jobIdx].id);
       // console.log("user")
       //// console.log(this.users[userIdx])
       // console.log(this.jobs)
       // console.log("Job name:")
       //  console.log(this.jobs[jobIdx].name)
        if(this.jobs[jobIdx].name.toUpperCase() !== "OFF") {
          this.totalHours += this.dRota[idx].halfHours / 2;
          this.totalPay += (this.dRota[idx].halfHours / 2) * payScale;
          this.timeCardHours += new TimeCard(this.dRota[idx].validateCheckin,this.dRota[idx].clockOut).getHoursWorked()
        }
        // let total = {}
        // total.totalHours = this.totalHours
        // total.totalPay = this.totalPay
        // this.jobTypes.set(this.jobType,total)
        // this.totalHours = 0
        // this.totalPay = 0

      }
    }
  },
  props: {

    rota: {
      type: Array,
      required: true
    },
    showPay: {
      type: Boolean,
      required: true,
    },
    employee: {
      type: Object,
      default: new User(),
    }

  },
  watch: {
    rota: {
      deep: true,
      handler() {
        this.$forceUpdate()
        this.setDRota();
      },
    },
    rotaLen:{
      deep:true,
      handler(){
        this.$forceUpdate()
      }

    }

  },
}
</script>

<style scoped>
.rectangle {
  margin: 13px;
  background-color: white;
  border: black 3px solid;
}

.bold {
  font-weight: bolder;
}

</style>
